"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const MessageIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({ viewBox: "0 0 30 30" }, props),
    react_1.default.createElement("path", { d: "m9 15.4h12v2.4h-12zm0-6.4h12v2.4h-12zm-4.732 17.716a2.4 2.4 0 0 0 2.464-0.12l4.196-2.8h12.072a4 4 0 0 0 4-3.996v-12.8a4 4 0 0 0-4-4h-16a4 4 0 0 0-4 4v17.6a2.4 2.4 0 0 0 1.268 2.116zm1.132-5.316v-14.4a1.6 1.6 0 0 1 1.6-1.6h16a1.6 1.6 0 0 1 1.6 1.6v12.8a1.6 1.6 0 0 1-1.6 1.6h-12.8l-4.8 3.2z" })));
exports.MessageIcon = MessageIcon;
exports.default = exports.MessageIcon;
